import { MdBugReport, MdDelete } from 'react-icons/md';
import { FaInfoCircle, FaSignOutAlt } from 'react-icons/fa';
import applicationSettings from '../../infrastructure/config';
import { Button, LinkButton } from '../common';
import { NavProps } from './types';

import styles from './Layout.module.css';

export const DesktopNav = ({ isClearChatDisabled, onAbout, onClearChat, onLogout }: NavProps) => (
  <nav className={styles.desktopNav}>
    <ul className={styles.headerNavList}>
      <li>
        <div>
          <Button
            className={styles.headerButtonIcon}
            icon={<MdDelete size={20} />}
            disabled={isClearChatDisabled}
            onClick={onClearChat}
          >
            <span className={styles.headerButtonText}>Clear chat</span>
          </Button>
        </div>
      </li>
      {!!applicationSettings.reportBugUrl && (
        <>
          <li>
            <div>
              <LinkButton
                className={styles.headerButtonIcon}
                icon={<MdBugReport size={20} />}
                href={applicationSettings.reportBugUrl}
              >
                <span className={styles.headerButtonText}>Report a bug</span>
              </LinkButton>
            </div>
          </li>
        </>
      )}
      <li>
        <div>
          <Button
            className={styles.headerButtonIcon}
            icon={<FaInfoCircle size={18} />}
            onClick={onAbout}
          >
            <span className={styles.headerButtonText}>About</span>
          </Button>
        </div>
      </li>
      <li>
        <div>
          <Button
            className={styles.headerButtonIcon}
            icon={<FaSignOutAlt size={18} />}
            onClick={onLogout}
          >
            <span className={styles.headerButtonText}>Sign out</span>
          </Button>
        </div>
      </li>
    </ul>
  </nav>
);
